import { H3 } from "@/common/elements";
import { CartonDetails } from "../styles";
import { KeyValueObj } from "@/common/types";
import { Pagination } from "@/common/components/pagination";

const CartonPreview = (data: KeyValueObj) => {
  return (
    <CartonDetails>
      <div className="title">
        <H3>Carton Serial</H3>
        <span>{data?.data?.serial_number}</span>
      </div>
      <div>
        {data?.data?.data === undefined ||
        data?.data?.data?.unit_serial?.length === 0 ? (
          <span>No data found</span>
        ) : (
          data?.data?.data?.unit_serial?.map((dataItem: KeyValueObj) => (
            <div className="packWrapper">
              <div>
                <h4>Pack Serial</h4>
                <span>{dataItem?.pack_number}</span>
              </div>
              <div>
                <h4>Serial Number ({dataItem?.serial_number?.length})</h4>
                <div className="serialWrapper">
                  {dataItem?.serial_number?.map((serial: KeyValueObj) => (
                    <span>{serial?.id}</span>
                  ))}
                </div>
              </div>
            </div>
          ))
        )}
      </div>
      <div className="paginationWrapper">
        <div className="paginationController">
          <Pagination
            onNextPage={() => alert("next requested")}
            onPerPageChange={() => alert("per page change")}
            pageCount={2}
            dontShowLabel={true}
          />
        </div>
      </div>
    </CartonDetails>
  );
};

export default CartonPreview;
